import { ProntuarioResponseStatus, ProntuarioResponseTipo } from '@/api/generated/model';

/**
 * Rótulos do prontuário.
 *
 * ⚠️ `editavel` vem do servidor e é quem decide se dá para editar ou excluir —
 * ele já pesa assinatura e cancelamento. Derivar do status na tela seria uma
 * segunda regra para divergir da primeira.
 */
export const TIPOS = Object.values(ProntuarioResponseTipo);

export const ROTULO_TIPO: Record<string, string> = {
  CONSULTA: 'Consulta',
  RETORNO: 'Retorno',
  PROCEDIMENTO: 'Procedimento',
  INTERNACAO: 'Internação',
  OBSERVACAO: 'Observação',
};

export const STATUS_PRONTUARIO = Object.values(ProntuarioResponseStatus);

export const ROTULO_STATUS_PRONTUARIO: Record<string, string> = {
  RASCUNHO: 'Rascunho',
  REGISTRADO: 'Registrado',
  ASSINADO: 'Assinado',
  CANCELADO: 'Cancelado',
};

export const CLASSE_STATUS_PRONTUARIO: Record<string, string> = {
  RASCUNHO: 'text-amber-600 border-amber-600/40',
  REGISTRADO: '',
  ASSINADO: 'text-emerald-600 border-emerald-600/40',
  CANCELADO: 'text-destructive border-destructive/40',
};

/**
 * `atendidoEm` é um instante, e o formulário usa `datetime-local`.
 *
 * O `<input type="datetime-local">` fala no fuso LOCAL e sem sufixo. Estas duas
 * funções fazem a ponte com o ISO em UTC que o servidor guarda — sem elas, o
 * horário do atendimento anda três horas a cada ida e volta.
 */
export function isoParaLocal(iso: string): string {
  const d = new Date(iso);
  const ajustado = new Date(d.getTime() - d.getTimezoneOffset() * 60_000);
  return ajustado.toISOString().slice(0, 16);
}

export function localParaISO(local: string): string {
  return new Date(local).toISOString();
}

export function formatarDataHora(iso: string): string {
  return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}
